module.exports = __webpack_public_path__ + "images/map/headquarter-570e423dfde2bc118bd3b764b78ff56c.png";